import { render } from "./ClubDetailsView.vue?vue&type=template&id=5bb69249"
import script from "./ClubDetailsView.vue?vue&type=script&lang=js"
export * from "./ClubDetailsView.vue?vue&type=script&lang=js"

import "./ClubDetailsView.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__